<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-academy.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Web3 Workshops
            </h1>
            <div class="intro">Everyone can benefit from a support system as they learn.  Introducing NFDaddys!</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <h3>Blockchain Basics</h3>
      <p>Monthly meetups to discuss the basics of the blockchain "Blockchain Basics" the first Sunday of EVERY month.</p>
      <p>The basics will be your superpower as you continue your mission to web3 accomplishments.</p>
      <p>&nbsp;</p>

      <h3>Digital Artist</h3>
      <p>Quarterly meetups to discuss the tools artists are using to create NFTs led by our master doodler Marcos. </p>
      <p>The meetups are teaching Procreate, Photoshop, Python and many more tools.</p>
      <p>&nbsp;</p>

      <h3>WEB 3 Developer</h3>
      <p>Quarterly meetups to discuss the tools web3 developers are using to create the backend structure that lives on the blockchain.</p>
      <p>The meetups are teaching Solidity, ERC721, ERC721a, and always exploring new blockchains.</p>
      <p>&nbsp;</p>

      <h3>SIGN UP!</h3>
      <p>If you are interested in signing up for any of our courses, please <a href="https://forms.gle/sJYTRfrucykLGvU2A" target="_blank">sign up here</a>.</p>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "Web3Workshops",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>